<script lang="ts">
  import { useRouteQuery } from '@gat-ship/lib/router'
  import { createContext } from 'reka-ui'
  import { ref, type Ref } from 'vue'

  export interface SelectMenuProviderProps {
    routeQueryParam?: string
    defaultSelectedValue: string
  }

  export type SelectMenuContext = {
    /** If any sub-components uses the provider, the mode will be 'provided'. */
    mode: 'provided' | 'not-provided'
    selectedValue: Ref<string>
    setSelectedValue: (selectedValue: string) => void
  }

  export const [_useSelectMenu, provideSelectMenu] =
    createContext<SelectMenuContext>('gs-select-menu')

  export function useSelectMenu(): SelectMenuContext {
    try {
      return _useSelectMenu()
    } catch (error) {
      return {
        mode: 'not-provided',
        selectedValue: ref<string>(''),
        setSelectedValue: (selectedValue: string) => {}
      }
    }
  }
</script>
<script setup lang="ts">
  const props = defineProps<SelectMenuProviderProps>()

  const selectedValue = props.routeQueryParam
    ? useRouteQuery<string>(props.routeQueryParam, props.defaultSelectedValue)
    : ref<string>(props.defaultSelectedValue)

  provideSelectMenu({
    mode: 'provided',
    selectedValue,
    setSelectedValue: (value: string) => {
      selectedValue.value = value
    }
  })
</script>
<template>
  <slot />
</template>
